import { useLocalStorage } from "@mantine/hooks";
import { useCallback, useEffect, useState } from "react";

export const useIframeControls = () => {
    const [controlPanelResolversByName, setControlPanelResolversByName] = useState(
        new Map() as ReadonlyMap<string, (value: HTMLElement) => void>,
    );

    const [showControlPanel, setShowControlPanel] = useLocalStorage({
        key: "show-control-panel",
        defaultValue: false,
    });

    const createContainer = useCallback((name: string) => {
        const { promise, resolve } = Promise.withResolvers<HTMLElement>();
        setControlPanelResolversByName((prevControlPanelResolversByName) =>
            new Map(prevControlPanelResolversByName).set(name, resolve),
        );
        return promise;
    }, []);

    useEffect(() => {
        if (!showControlPanel) return;
        if (import.meta.env.VITE_ENV_TYPE === "production") setShowControlPanel(false);
    }, [setShowControlPanel, showControlPanel]);

    return { controlPanelResolversByName, showControlPanel, setShowControlPanel, createContainer };
};
